
// -- beyours edd -- 
// let pincodeData;
// function binarySearch(data, targetPincode) {
//   let left = 0;
//   let right = data.length - 1;
//   let day = '';
//   while (left <= right) {
//     let mid = Math.floor((left + right) / 2);
//     let midPincode = data[mid].pincode;

//     if (midPincode == targetPincode) {
//       day = data[mid].date; // Set date when pincode is found
//       return { exists: true, day: day};
//     } else if (midPincode < targetPincode) {
//       left = mid + 1;
//     } else {
//       right = mid - 1;
//     }
//   }
//   return false; // Pincode not found
// }
// function prefetchPincode(){
//   var apiUrl = 'https://script.google.com/macros/s/AKfycbzd3jvoxMjAUaHU7UHCLCYdsMVxjCf1pAEv5jwJ7foL9r89iBWoTRebRx5Ssj4IyYXL/exec';

//   fetch(apiUrl)
//     .then((response) => response.json())
//     .then(value => {
//       pincodeData = value.data;
//     })
//     .catch(error => {
//       console.log('Error prefetching data:', error);
//     })
// }

// function checkDelivery(event){
//   event.preventDefault(); // Prevent form submission
//   // document.getElementById("pincode-loader").style.display = "block"; // Show loading animation
//   document.getElementById("delivery-box").style.display = "none"; // Hide delivery message
//   var currentPincode = parseInt(document.getElementById("pincode-input").value);
//   let data = pincodeData;
//   let now = new Date();
//   let currentTime = now.getHours() * 100 + now.getMinutes();
//   let date1 = new Date(now);
//   let date2 = new Date(now);
//   let result = binarySearch(data, currentPincode);
//   if(result.exists){
//     if(result.day == 1){
//       if(currentTime < 1300){
//         document.getElementById("delivery-message").innerHTML = `Superfast Delivery by tomorrow`;
//       }else{
//         document.getElementById("delivery-message").innerText = `Superfast Delivery by tomorrow`;
//       }
//     }else{
      
//       let days = parseInt(result.day);
//       if(currentTime > 1500){
//         days = days + 1;
//       }
//       date1.setDate(now.getDate() + days - 1);
//       date2.setDate(now.getDate() + days);
//       let day1 = date1.getDate();
//       let day2 = date2.getDate();
//       let month1 = date1.toLocaleString('default', { month: 'short' });
//       let month2 = date2.toLocaleString('default', { month: 'short' });
//       document.getElementById("delivery-message").innerText = `${day1} ${month1} - ${day2} ${month2} `;
//     }
//   }else{
//     date1.setDate(now.getDate() + 4);
//     date2.setDate(now.getDate() + 6);
//     let day1 = date1.getDate();
//     let day2 = date2.getDate();
//     let month1 = date1.toLocaleString('default', { month: 'short' });
//     let month2 = date2.toLocaleString('default', { month: 'short' });
//     document.getElementById("delivery-message").innerText = `${day1} ${month1} - ${day2} ${month2} `;
//   }
//   // document.getElementById("pincode-loader").style.display = "none"; // Hide loading animation after response
//   document.getElementById("delivery-box").style.display = "grid"; // Show delivery message
// }

// prefetchPincode();
// const showEdd = document.querySelector('.show-edd');

// if (showEdd) {
//   const closeEdd = document.querySelector('.close-edd');

//   const today = new Date().toDateString();
//   const lastShown = localStorage.getItem('popupLastShown');


//   if (lastShown !== today) {
//     showEdd.classList.add('pop-edd');
//     closeEdd.classList.remove('hidden');
//     localStorage.setItem('popupLastShown', today);
//   }

//   closeEdd.addEventListener("click", () => {
//     console.log("sandeep");
//     showEdd.classList.remove('pop-edd');
//     closeEdd.classList.add('hidden');
//   });
// }

class EDDChecker extends HTMLElement {
  constructor() {
    super();
    this.API_URL = "https://script.google.com/macros/s/AKfycbzd3jvoxMjAUaHU7UHCLCYdsMVxjCf1pAEv5jwJ7foL9r89iBWoTRebRx5Ssj4IyYXL/exec";
    this.pincodeData = JSON.parse(localStorage.getItem("pincodeData")) || [];
  }

  connectedCallback() {
    const form = this.querySelector("#pincode-form");
    const input = this.querySelector("#pincode-input");
    const deliveryBox = this.querySelector("#delivery-box");

    form.addEventListener("submit", (e) => this.checkDelivery(e));

    // Fetch pincode data if older than 1 day
    if (!localStorage.getItem("dataTimestamp") || Date.now() - localStorage.getItem("dataTimestamp") > 86400000) {
      this.fetchPincodeData();
    }

    // Always show popup on load
    // deliveryBox.classList.remove("hidden");

    // Auto-fill and show EDD if saved pincode exists
    const savedPincode = localStorage.getItem("lastPincode");
    if (savedPincode && /^\d{6}$/.test(savedPincode)) {
      input.value = savedPincode;
      this.showEDD(savedPincode);
    }
  }

  async fetchPincodeData() {
    try {
      let response = await fetch(this.API_URL);
      let data = await response.json();
      if (data?.data?.length) {
        this.pincodeData = data.data;
        localStorage.setItem("pincodeData", JSON.stringify(this.pincodeData));
        localStorage.setItem("dataTimestamp", Date.now());
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  binarySearch(target) {
    let left = 0, right = this.pincodeData.length - 1;
    while (left <= right) {
      let mid = Math.floor((left + right) / 2);
      if (+this.pincodeData[mid].pincode === target) return +this.pincodeData[mid].date;
      this.pincodeData[mid].pincode < target ? (left = mid + 1) : (right = mid - 1);
    }
    return 5; // Default delivery days
  }

  checkDelivery(event) {
    event.preventDefault();
    const input = this.querySelector("#pincode-input");
    const pincode = input.value.trim();

    if (!/^\d{6}$/.test(pincode)) {
      return (this.querySelector("#delivery-message").innerText = "Invalid Pincode");
    }

    localStorage.setItem("lastPincode", pincode); // Save pincode
    this.showEDD(pincode);
  }

  showEDD(pincode) {
    const deliveryBox = this.querySelector("#delivery-box");
    const deliveryMsg = this.querySelector("#delivery-message");

    let days = this.binarySearch(+pincode);
    let now = new Date();
    let date1 = new Date(now);
    let date2 = new Date(now);
    date1.setDate(now.getDate() + days - 1);
    date2.setDate(now.getDate() + days);

    deliveryBox.classList.remove("hidden");
    deliveryMsg.innerText =
      `Delivered by ${date1.getDate()} ${date1.toLocaleString("default", { month: "short" })} - ` +
      `${date2.getDate()} ${date2.toLocaleString("default", { month: "short" })}`;
  }
}

customElements.define("edd-checker", EDDChecker);


const copyCode = async(text, event) => {
  event.preventDefault();
  
  try {
    await navigator.clipboard.writeText(text);
    document.querySelector('.notification__text').innerHTML = `Copied to Clipboard - ${text}`;
    document.getElementById('copyNotification').classList.add('is--active');

    setTimeout(()=>{
      document.getElementById('copyNotification').classList.remove('is--active');
    },3000);
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
}
// The Add to Bag bar used to pin itself to the bottom of the viewport past 300px of
// scroll. It now stays in the flow directly under the size picker, so the price, the pack
// choice and the button are read as one block instead of the button following the customer
// around. Any .its-fixed left on the element by a cached script is stripped defensively.
window.addEventListener("scroll", function () {
  const addBtn = document.querySelector('.product-form-alternate .product-form__payment-container');
  if (addBtn) addBtn.classList.remove("its-fixed");
});